export const statsTranslations = {
  ru: {
    title: "Статистика сервера",
    subtitle: "Мониторинг онлайна и активности игроков.",
    copied: "Скопировано!",
    onlineNow: "Сейчас онлайн",
    gatheringStats: "Сбор статистики...",
    chartPlayers: "Игроки",
    tabs: {
      all: "Все игроки",
      online: "Сейчас играют",
      today: "Сегодня",
      yesterday: "Вчера",
      week: "За неделю",
      month: "За месяц"
    },
    searchPlaceholder: "Поиск игрока...",
    sort: {
      playtime: "По часам",
      lastSeen: "По онлайну",
      name: "По алфавиту"
    },
    loadingPlayers: "Загрузка игроков...",
    notFoundTitle: "Не найдено",
    notFoundDesc: "По вашему запросу никого не найдено.",
    playedHours: "Отыграно: {hours} ч.",
    inGameNow: "В игре прямо сейчас",
    lastSeen: "Был(а): {date} в {time}",
    loadingMore: "Загрузка...",
    showMore: "Показать еще"
  },
  en: {
    title: "Server Statistics",
    subtitle: "Monitoring online and player activity.",
    copied: "Copied!",
    onlineNow: "Online now",
    gatheringStats: "Collecting statistics...",
    chartPlayers: "Players",
    tabs: {
      all: "All players",
      online: "Playing now",
      today: "Today",
      yesterday: "Yesterday",
      week: "This week",
      month: "This month"
    },
    searchPlaceholder: "Search player...",
    sort: {
      playtime: "By playtime",
      lastSeen: "By last seen",
      name: "Alphabetically"
    },
    loadingPlayers: "Loading players...",
    notFoundTitle: "Not found",
    notFoundDesc: "No one found for your request.",
    playedHours: "Played: {hours} h.",
    inGameNow: "In-game right now",
    lastSeen: "Last seen: {date} at {time}",
    loadingMore: "Loading...",
    showMore: "Show more"
  }
};